const requirement = {
  state: {
    searchText: ""
  },
  mutations: {
    SET_SEARCH_TEXT: (state, searchText) => {
      state.searchText = searchText
    },
  }
}
export default requirement
